<template>
  <res-select :id="elementId"  v-model="selectedYear" :items="years" :attach="attachId" :loading="loading" :readonly="readonly" :placeholder="'select'"></res-select>
</template>

<script>
  import ResSelect from '@/components/base/ResSelect.vue';
  import budgetService from '@/services/budget';

  export default {
    name: 'bulkCreationsYearSelector',
    components: {
      ResSelect
    },
    data() {
      return {
        years: [],
        loading: true
      }
    },
    props: {
      value: {
        required: true
      },
      elementId: {
        type: String,
        default: "budget-year-selector"
      },
      readonly: {
        type: Boolean,
        default: false
      },
     triggerLoad: {
        type: Number,
        default: 0
      }
    },
    computed: {
      selectedYear: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
      attachId() {
        return '#' + this.elementId;
      }
    },
    methods: {
      async loadYears() {
        this.loading = true;
        let yearData = await budgetService.getExistingBulkCreationYears();
        if (yearData && yearData.length > 0) {
          let ys = [];
          for (var i = 0; i < yearData.length; i++) {
            ys.push({ text: yearData[i], value: yearData[i] });
          }
          this.years = ys;
        } else {
          let ys = [];
          this.years = ys;
        }
        this.loading = false;
        this.$emit('existing-years-loaded', this.years)
      },
    },
    watch: {
      triggerLoad: {
        deep: true,
        immediate: true,
        async handler() {
          var self = this;          
            await self.loadYears();
        }
      },
    }
  }
</script>
